import { useCallback } from 'react';
import { usePayment } from '../context/PaymentContext';

export const useWalletPayment = () => {
  const {
    amountWallet,
    setAmountWallet,
    getMaxAmounts,
    loading,
    calculateRemainingPrice,
    setSelectedPaymentMethod,
  } = usePayment();

  // Validar e atualizar valor do Wallet
  const handleAmountChange = useCallback((value, combinePayment, totalPrice) => {
    const maxAmounts = getMaxAmounts();
    let validValue = 0;
    if (combinePayment) {
      validValue = value && value > 0 ? Math.min(parseFloat(value), maxAmounts.maxWallet) : 0;
    } else {
      // Para pagamento único, usar o valor total como o valor para wallet
      validValue = Math.min(totalPrice, maxAmounts.maxWallet);
    }

    setAmountWallet(validValue);
    if (!combinePayment) {
      if (validValue > 0) {
        setSelectedPaymentMethod("wallet");
      } else {
        setSelectedPaymentMethod(null);
      }
    }
  }, [setAmountWallet, getMaxAmounts, setSelectedPaymentMethod]);

  // Validar se pode prosseguir com o Wallet
  const canProceed = useCallback(() => {
    const remaining = calculateRemainingPrice();
    return amountWallet > 0 ? remaining === 0 : true;
  }, [amountWallet, calculateRemainingPrice]);

  // Limpar dados do Wallet
  const clearWalletPayment = useCallback(() => {
    setAmountWallet(0);
  }, [setAmountWallet]);

  return {
    amountWallet,
    maxAmount: getMaxAmounts().maxWallet,
    loading,
    handleAmountChange,
    canProceed,
    clearWalletPayment,
  };
};
